import { Component } from '@angular/core';

@Component({
  selector: 'lgb-brand',
  standalone: false,
  templateUrl: './brand.html',
  styleUrl: './brand.css',
})
export class Brand {

}
